export default class TwoFX {

    static preload(scene){
        scene.load.atlas('flares', 'src/assets/particles/flares/flares.png', 'src/assets/particles/flares/flares.json');
        scene.load.image('dot', 'src/assets/particles/dot/dot.png');
        scene.load.image('leaf', 'src/assets/particles/leaves/leaves_3.png');
    }

    static init(scene, depth = 999){
        this.scene = scene;
        this.depth = 999;
    }

    static emitFlares(){
        const shape1 = new Phaser.Geom.Circle(0, 0, 160);
        const shape2 = new Phaser.Geom.Ellipse(0, 0, 500, 150);
        const shape3 = new Phaser.Geom.Rectangle(-150, -150, 300, 300);
        const shape4 = new Phaser.Geom.Line(-150, -150, 150, 150);
        const shape5 = new Phaser.Geom.Triangle.BuildEquilateral(0, -140, 300);

        const emitter = this.scene.add.particles(400, 300, 'flares', {
            frame: { frames: [ 'red', 'green', 'blue', 'white', 'yellow' ], cycle: true },
            blendMode: 'ADD',
            lifespan: 500,
            quantity: 4,
            scale: { start: 0.5, end: 0.1 }
        });
        emitter.setDepth(10);

        emitter.addEmitZone({ type: 'edge', source: shape1, quantity: 64, total: 1 });
        emitter.addEmitZone({ type: 'edge', source: shape2, quantity: 64, total: 1 });
        emitter.addEmitZone({ type: 'edge', source: shape3, quantity: 64, total: 1 });
        emitter.addEmitZone({ type: 'edge', source: shape4, quantity: 64, total: 1 });
        emitter.addEmitZone({ type: 'edge', source: shape5, quantity: 64, total: 1 });
    }

    static createFrameEmitter(bounds){

        return this.scene.add.particles(0, 0, 'dot', {
            speed: 24,
            lifespan: 1500,
            quantity: 10,
            scale: { start: 0.4, end: 0 },
            emitting: false,
            emitZone: { type: 'edge', source: bounds, quantity: 42 },
            duration: 500
        });
    }

    static emitFrame(emitter){
        emitter.start(2000);
    }

    static emitLeaves(){
        this.leavesEmitter = this.scene.add.particles(0, -100, 'leaf', {
            x: {min: 0, max: 720},
            tint: { min: 0x13F1B4, max: 0xF3F1B4},
            speedX: {min: -100, max: 100},
            speedY: {min: 50, max: 500},
            lifespan: 10000,
            quantity: 1,
            scale: {min: 0.05, max: 0.1},
            rotate: {start: 0, end: 270},
            frequency: 100,
            //gravityY: 100,
        });
        this.leavesEmitter.setDepth(-1);
        this.leavesEmitter.start();
    }

}